import React, { lazy } from 'react';
import { withLoadingAndErrorStates } from '@guildeducationinc/mfe-utils';
import { ShimmerLoader } from '@guildeducationinc/recess';
import { useIsMobile, useIsTablet } from '@guildeducationinc/catalog-tools';
import { logDataDogError } from '@src/utilities/datadog';

const ShelfRemote = lazy(() => import(/* webpackChunkName: "remote/Shelf" */ 'CatalogTools/Shelf'));

const ShelfLoading = () => {
	const isMobile = useIsMobile();
	const isTablet = useIsTablet();

	if (isMobile) {
		return <ShimmerLoader height={250} label='Shelf' loaded={false} width='100%' />;
	}

	return (
		<ShimmerLoader
			count={isTablet ? 2 : 3}
			height={250}
			inline
			inlineMargin={16}
			label='Shelf'
			loaded={false}
			width={200}
		/>
	);
};

export const Shelf = withLoadingAndErrorStates({
	component: ShelfRemote,
	errorAs: (error, componentStack) => {
		logDataDogError(error, 'ShelfRemoteError', { componentStack });
		return <></>;
	},
	loadingAs: ShelfLoading,
});
